import {strip} from '@/common/questionsExporter/utility'

const textBlockQuestion = (question) => {
    return strip(question.question ? question.question : '')
}

export {textBlockQuestion}
